import { Title, Text } from './style'


export function PartnerSuport(){
  return(
    <>
      <Title
        variant="h2">
          Nossos Parceiros
      </Title>
      <Text
        variant="body1">
          Nossa atuação é facilitada com o apoio de nossos parceiros corporativos, que nos dão<br />
          suporte em nossos programas e nos capacitam a servir a população LGBTQ+.
      </Text>
    </>
  )

}